import React from 'react';
import { Redirect, Route, RouteComponentProps, Switch, useRouteMatch } from 'react-router-dom';

import { withMaintenanceCheck } from '@/hocs';
import { WalletUIState } from '@/model/wallets/types';
import { withWithdrawalInitialization } from '@/pages/withdrawal/hocs';

import { withWalletsInitialization } from './hocs';
import { TransactionPage, TransactionsPage } from './pages';

const DefaultRoute: React.FC<RouteComponentProps> = ({ location, match: { path } }: RouteComponentProps) => {
  console.warn(`URL not found: ${location.pathname}`);
  return <Redirect to={`${path}/${WalletUIState.TRANSACTIONS}`} />;
};

export const WalletsPage: React.FC = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/${WalletUIState.TRANSACTION}/*`} component={TransactionPage} />
      <Route path={`${path}/${WalletUIState.TRANSACTIONS}`} component={TransactionsPage} />
      <Route path={`${path}/${WalletUIState.TRANSACTIONS}/*`} component={TransactionsPage} />
      <Route component={DefaultRoute} />
    </Switch>
  );
};

export default withMaintenanceCheck('demoDisabled')(
  withWithdrawalInitialization(false)(withWalletsInitialization(WalletsPage)),
);
